import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

// FIXME generic?
export interface HeadlineProps extends ComponentProps<'h2'> {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  size?: 1 | 2 | 3 | 4 | 5
}

const sizes = {
  1: 'text-h1 xs:@small:text-h1-xs',
  2: 'text-h2 xs:@small:text-h2-xs',
  3: 'text-h3 xs:@small:text-h3-xs',
  4: 'text-p1',
  5: 'text-p2',
}

export const Headline = ({tag: Tag = 'h2', size = 2, children, className, ...restProps}: HeadlineProps) => (
  <Tag
    className={twMerge(sizes[size], className)}
    {...restProps}
  >
    {children}
  </Tag>
)
